import { render, staticRenderFns } from "./ModalResultadosLabAux.vue?vue&type=template&id=4ec6e91e"
import script from "./ModalResultadosLabAux.vue?vue&type=script&lang=js"
export * from "./ModalResultadosLabAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports